<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="ack" epub:type="acknowledgments" role="doc-acknowledgments">
<header>
<h1 class="FMH" id="ack"><span aria-label=" Page xiii. " epub:type="pagebreak" id="pg_xiii" role="doc-pagebreak"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><b>acknowledgments</b></span></span></h1>
</header>
<p class="FMTNI">Thank you to everyone who read this in the early stages. All my love and gratitude go to my mother, Claudia, for all her support, always: and to my sister, Jemima, for her advice and feedback.</p>
<p class="FMTX">Deep love and thanks to Emma, of course, for everything.</p>
<p class="FMTX">My heartfelt thanks to Max Schaefer, who gave me invaluable criticisms, hours of word-processing help, and great friendship during a generally rubbish year.</p>
<p class="FMTX">I can never thank Mic Cheetham enough. I am incredibly lucky to have her on my side. And thanks to all at Macmillan, particularly Peter Lavery, and at Tor, particularly Brian Cholfin and Jenna Felice.</p>
<p class="FMTX">I owe too many writers and artists to mention, but respect is especially due to Two Fingers and James T. Kirk for their novel <i>Junglist.</i> They blazed a trail. Many thanks also to Iain Sinclair for generously letting me keep the metaphor I accidently stole from him. Jake Pilikian introduced me to Drum and Bass music and changed my life. Big up to all the DJs and Crews who provided a soundtrack. Awe and gratitude especially to A Guy Called Gerald for the sublime <i>Gloc</i>: old, now, but still the most terrifying slab of guerrilla bass ever committed to vinyl. Rewind.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?5c0bd2f0